











































import { index, destroy, qrcode } from '@/api/mini_programs'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  config: Record<string, any> = {
    api: index,
    include: 'brand',
    paginate: true,
    fields: [
      { prop: 'id', label: '#', width: 60 },
      { prop: 'avatar', label: 'T', slot: true, width: 80 },
      { prop: 'name', label: 'Name' },
      { prop: 'company', label: 'Company', slot: true },
      { prop: 'mobile', label: 'Mobile', slot: true },
      { prop: 'appid', label: 'AppID', width: 200 },
      { prop: 'version', label: 'Version', width: 100 },
      { prop: 'status', label: 'Status', slot: true, width: 120 },
      { prop: 'created_at', label: 'Created time', width: 150 }
    ]
  }

  async destroyRow (row: Record<string, any>) {
    this.$ask(async () => {
      await destroy(row.id)
      const el: any = this.$refs.table
      el.getItems(1)
      this.$message.success('Data has been deleted')
    })
  }

  async downMiniProgramQrCode (row: Record<string, any>) {
    this.$message.info('小程序码生成中...')
    const axiosResponse: Record<string, any> = await qrcode(row.id)
    window.open(axiosResponse.data.url)
  }
}
